
const newModel = () => {
    return {
        TruongMamnonGiaovienId: null,
        truongMamnonId: null,
        tenTruongMamnon: null,
        idKy: null,
        tenKy: null,
        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,
        ghiChu: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        TruongMamnonGiaovienId: null,
        truongMamnonId: null,
        tenPhanloaiTruongMamnon: null,
        idKy: null,
        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        TruongMamnonGiaovienId: item.TruongMamnonGiaovienId,
        truongMamnonId: item.truongMamnonId,
        tenTruongMamnon: item.tenTruongMamnon,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongMamnonGiaovienId: item.truongMamnonGiaovienId,
        truongMamnonId: item.truongMamnonId,
        tenPhanloaiTruongMamnon: null,
        idKy: item.idKy,
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongMamnonId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongMamnonId: item.truongMamnonId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        TruongMamnonGiaovienId: null,
        truongMamnonId: null,
        idKy: null,
        tongsoGiaovien: null,
        giaovienNu: null,
        giaovienDantocThieuso: null,
        giaovienDatchuan: null,
        ghiChu: null,
        enabled: null,
    }
}

export const truongMamnonGiaovienModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


